import React from 'react';
import ajax from '../../ajax';
import functions from '../../functions';


class FilterBusinessLoans extends React.Component {
  
  state={
    userId:functions.sessionGuard(),
    value:'...',
    title:'Business Loans',
    filter:'BUSINESS'
  }
  async componentDidMount()
  {
    await this.requestRecord();
    this.timer = setTimeout(this.func=async()=> {
      await this.requestRecord();
      this.timer = setTimeout(this.func, 2000); // (*)
    }, 2000);
  }

  componentWillUnmount()
  {
    clearTimeout(this.timer)
  }

  requestRecord=async()=>{
    const server_response=await ajax.countBusinessLoanRecords(this.state.userId);
    if(server_response.status==="OK")
    {
      this.setState({
        value:server_response.details.total_c
      })
    }
  }

  render(){
      return (
        <button 
          type="button" 
          className="btn ripple btn-secondary btn-sm"
          onClick={()=>this.props.onClick(this.state.filter, this.state.title)}>
          {this.state.title} <span className="badge badge-dark ml-2">{this.state.value}</span>
        </button>
      );
    
 
  }
}

export default FilterBusinessLoans;